import { BLOCKS } from '@contentful/rich-text-types';
import { convertTextToId } from './convertTextToId';
export var getHeadingsFromDocumentBlock = function getHeadingsFromDocumentBlock(richTextDocument) {
  var _richTextDocument$con;

  var nodeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : BLOCKS.HEADING_3;

  if (!richTextDocument) {
    return [];
  }

  var headings = (_richTextDocument$con = richTextDocument.content) === null || _richTextDocument$con === void 0 ? void 0 : _richTextDocument$con.filter(function (item) {
    return item.nodeType === nodeType;
  });
  return headings.map(function (item) {
    var value = item['content'][0]['value'];
    return {
      heading: value,
      id: convertTextToId(value)
    };
  });
};
export { BLOCKS };